import type { ReactNode } from "react";
import pdfWorkerUrl from "pdfjs-dist/build/pdf.worker.min.mjs?url";
import { toast } from "@lumanity/ui/primitives";
import { DocumentViewerProvider, DocumentViewerSheet, configurePdfWorker } from "@lumanity/ui/viewer";

// pdf.js runs in a worker; serve PubCreator's own copy rather than the unpkg fallback.
configurePdfWorker(pdfWorkerUrl);

/**
 * The evidence-document viewer for the whole app: holds which document is
 * open (`useDocumentViewer().openDocument`, used by the Evidence Base's eye
 * button and by chat citations) and renders the one side sheet that shows it.
 * Mount once, inside PubCreatorLumanityProvider (it fetches files through the
 * evidence-base client) and around the router.
 */
export function EvidenceViewerProvider({ children }: Readonly<{ children: ReactNode }>) {
  return (
    <DocumentViewerProvider>
      {children}
      <DocumentViewerSheet onError={({ message }) => toast({ title: "Document viewer", description: message, variant: "destructive" })} />
    </DocumentViewerProvider>
  );
}
